// TODO: add prop types and default props and remove this linter bypass
/* eslint react/prop-types: 1 */
import React, { useContext } from 'react';
import _isEmpty from 'lodash/isEmpty';

import { extractAvatarUrl } from 'common/utils/user';
import { LoggedInUserContext } from '../../contexts';

import HeaderView from './HeaderView';

const Header = () => {
  const { loggedInUser } = useContext(LoggedInUserContext);
  const avatarUrl = extractAvatarUrl(loggedInUser);
  let name = '';

  if (!_isEmpty(loggedInUser) && !avatarUrl) {
    const { genres } = loggedInUser;
    const userInfo = genres && genres.find(e => e.description === 'user-info');
    const personal = userInfo && userInfo.sections.find(o => o.description === 'personal');
    const personalName = personal && personal.attribute_types.find(r => r.description === 'Name');
    name = `${personalName?.attributes[0].value || ''}`;
  }

  return <HeaderView avatarUrl={avatarUrl} name={name} />;
};

export default Header;
